import {
  Button,
  Center,
  Heading,
  HStack,
  Icon,
  Text,
  useDisclosure,
  VStack
} from "@chakra-ui/react";

import { TbBuildingBank, TbFileUpload } from "react-icons/tb";
import { useSelector } from "react-redux";

import Barrier from "@/components/common/permission/Barrier";
import { ConnectBank } from "@/routes/lazyFeatures";
import { selectCompany } from "@/store/features/companies/companies";

import { AddBank } from "./AddBank";

export const EmptyScreen = () => {
  const addBankDisclosure = useDisclosure();
  const connectBankDisclosure = useDisclosure();
  const company = useSelector(selectCompany);

  return (
    <Center>
      <VStack color="secondary.700" mt={28} maxW={560} spacing={6}>
        <Heading fontSize={28} fontWeight={600}>
          Welcome to Bank Reconciliation
        </Heading>

        <Text
          fontWeight={500}
          color="gray.600"
          fontSize={14}
          textAlign="center"
        >
          Get started by selecting how you will bring {company?.name} bank
          transactions into Jack for matching and document management.
        </Text>

        <Barrier show when="company.connections.bank-reconciliation">
          <HStack spacing={5} textAlign="center" mt={8}>
            <VStack bg="white" rounded={6} spacing={2} py={6} px={4} w={199}>
              <Icon fontSize={24} color="secondary.300" as={TbFileUpload} />
              <Text fontSize={17} fontWeight={600}>
                Add <br /> Manually
              </Text>
              <Text fontSize={14}>
                Create a bank, add an account, and upload your statement.
              </Text>

              <Button
                onClick={addBankDisclosure.onOpen}
                size="sm"
                w={110}
                mt={3}
                h={9}
              >
                Add Bank
              </Button>
            </VStack>

            <VStack bg="white" rounded={6} spacing={2} py={6} px={4} w={199}>
              <Icon fontSize={24} color="secondary.300" as={TbBuildingBank} />
              <Text fontSize={17} fontWeight={600}>
                Connect to <br /> Open Banking
              </Text>
              <Text fontSize={14}>
                Connect your bank, select an account, and import transactions.
              </Text>

              <Button
                onClick={connectBankDisclosure.onOpen}
                size="sm"
                w={130}
                mt={3}
                h={9}
              >
                Connect Yapily
              </Button>
            </VStack>
          </HStack>
        </Barrier>
      </VStack>

      {addBankDisclosure.isOpen && <AddBank {...addBankDisclosure} />}
      {connectBankDisclosure.isOpen && (
        <ConnectBank {...connectBankDisclosure} />
      )}
    </Center>
  );
};
